(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXDeleteController',CloudPBXDeleteController);

    CloudPBXDeleteController.$inject = ['$uibModalInstance', 'entity', 'CloudPBX'];

    function CloudPBXDeleteController($uibModalInstance, entity, CloudPBX) {
        var vm = this;

        vm.cloudPBX = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CloudPBX.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
